import { render } from "./designImagePreview.vue?vue&type=template&id=9d96b6ae&scoped=true"
import script from "./designImagePreview.vue?vue&type=script&lang=js"
export * from "./designImagePreview.vue?vue&type=script&lang=js"

import "./designImagePreview.vue?vue&type=style&index=0&id=9d96b6ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d96b6ae"]])

export default __exports__